import React, { Component, useContext } from 'react';
import { BrowserRouter, HashRouter} from 'react-router-dom';
import configureStore from '../../config/configureStore';
import { Provider } from 'react-redux';
import ScrollToTop from '../../utils/ScrollToTop';
import '../../assets/base.scss';
import Login from '../../pages/PagesLogin';
import Reset from '../../pages/Reset';
import Routes from '../../RoutesU';
import CssBaseline from '@material-ui/core/CssBaseline';
import { CookiesProvider } from 'react-cookie';

const store = configureStore();


class AuthenticatedApp extends Component {   
    render() {              
      return (
        <Provider store={store}>
          <HashRouter basename="/autogestion">
            <CssBaseline />
            <ScrollToTop>     
            <CookiesProvider>     
            <Routes />
            </CookiesProvider>
            </ScrollToTop>
          </HashRouter>
        </Provider>
      );
    }
  }
  
  export default AuthenticatedApp;